// const devApiUrl = "https://hsjapidev.hulian120.com"; //本地开发环
// const devApiUrl = "http://47.93.160.16:9088"; //本地开发环
const devApiUrl = "https://hsjapidev.hulian120.com"; //本地开发环

const buildDevApiUrl = "http://47.93.160.16:9088"; //打包开发环境
const buildDevTestApiUrl = "http://47.93.160.16:9088"; //打包开发测试环境
const buildTestApiUrl = "http://47.93.160.16:9188"; //打包测试环境
const buildPreApiUrl = "https://hsjapidev.hulian120.com"; //打包预发布环境
const buildLocaApiUrl = "http://localhost:9088"; //打包后端调试环境
const buildProApiUrl = "https://hsjapi.hulian120.com"; //打包正式环境

let useApiUrl,
  isReleaseEnv = false,
  wxApiUrlPrefix = "https://devmpauth.hulian120.com"; //这里是预发布环境，护士帮帮护士

if (process.env.NODE_ENV === "development") {
  useApiUrl = devApiUrl;
} else {
  //production
  switch (process.env.VUE_APP_MODE) {
    case "buildLoca":
      useApiUrl = buildLocaApiUrl;
      break;
    case "buildDev":
      useApiUrl = buildDevApiUrl;
      break;
    case "buildDevTest":
      useApiUrl = buildDevTestApiUrl;
      break;
    case "buildTest":
      useApiUrl = buildTestApiUrl;
      break;
    case "buildPre":
      useApiUrl = buildPreApiUrl;
      break;
    default:
      useApiUrl = buildProApiUrl;
      isReleaseEnv = true;
      wxApiUrlPrefix = "https://wxauth.hulian120.com"; //正式，护士加
      break;
  }
}

export { useApiUrl, isReleaseEnv, wxApiUrlPrefix }; //可以导出更多需要不同环境区分的url
